import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/naris.webp';
import screenshot_target from '../../../images/letterfunnel/dennisvandenende.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Dennis Van Den Ende"
      firstname="Dennis"
      companyname="Naris"
      competition="Key Control Dashboard en CERRIX"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/dennisvandenende.js